module.exports = __webpack_public_path__ + "ondemand/static/e3056e037/media/background-image-favourites-2x3.jpg";